import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateCustomQuestionComponent } from './create-custom-question.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { FormsModule } from '@angular/forms';
import { SortByPipeModule } from 'src/app/pipes/sort-pipe/sort-by.module';
import { LikertAnswerComponent } from './components/likert-answer/likert-answer.component';
import { MeasuredAnswerComponent } from './components/measured-answer/measured-answer.component';
import { ChoiceAnswerComponent } from './components/choice-answer/choice-answer.component';
import { TextboxAnswerComponent } from './components/textbox-answer/textbox-answer.component';
import { YesnoAnswerComponent } from './components/yesno-answer/yesno-answer.component';
import { MatrixAnswerComponent } from './components/matrix-answer/matrix-answer.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import {
  DropdownModule,
  ButtonModule,
  CheckboxModule,
  InputsModule
} from '@xref/xref-lib';



@NgModule({
  declarations: [
    CreateCustomQuestionComponent,
    LikertAnswerComponent,
    MeasuredAnswerComponent,
    ChoiceAnswerComponent,
    TextboxAnswerComponent,
    YesnoAnswerComponent,
    MatrixAnswerComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    BsDropdownModule.forRoot(),
    SortByPipeModule,
    TooltipModule.forRoot(),
    DropdownModule,
    CheckboxModule,
    ButtonModule,
    InputsModule
  ]
})
export class CreateCustomQuestionModule { }
